module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stock-output"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/Stock"
    }
  }, [_vm._v(_vm._s(_vm.$t('Stock')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/shop_order_list"
    }
  }, [_vm._v(_vm._s(_vm.$t('Comfirm Order')))])], 1), _vm._m(0)]), _vm._m(1), _c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-1 control-label text-right"
  }, [_vm._v("発注方法")]), _c('div', {
    staticClass: "col-sm-11"
  }, [_c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderMethod),
      expression: "orderMethod"
    }],
    attrs: {
      "type": "radio",
      "value": "fax"
    },
    domProps: {
      "checked": _vm._q(_vm.orderMethod, "fax")
    },
    on: {
      "click": function($event) {
        _vm.orderMethod = "fax"
      }
    }
  }), _c('span', [_vm._v("FAX")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderMethod),
      expression: "orderMethod"
    }],
    attrs: {
      "type": "radio",
      "value": "email"
    },
    domProps: {
      "checked": _vm._q(_vm.orderMethod, "email")
    },
    on: {
      "click": function($event) {
        _vm.orderMethod = "email"
      }
    }
  }), _c('span', [_vm._v("e-mail")])]), _c('label', {
    staticClass: "radio-inline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.orderMethod),
      expression: "orderMethod"
    }],
    attrs: {
      "type": "radio",
      "value": "tanomail"
    },
    domProps: {
      "checked": _vm._q(_vm.orderMethod, "tanomail")
    },
    on: {
      "click": function($event) {
        _vm.orderMethod = "tanomail"
      }
    }
  }), _c('span', [_vm._v("たのめーる")])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }), _c('div', {
    staticClass: "col-sm-2"
  }, [_c('button', {
    staticClass: "btn btn-block btn-primary btn-lg",
    attrs: {
      "disabled": !_vm.orderMethod
    },
    on: {
      "click": function($event) {
        _vm.outputClick()
      }
    }
  }, [_vm._v("出力")])])]), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "stockOutput",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _c('div', {
    staticClass: "modal-body"
  }, [_vm._m(3), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.remark),
      expression: "remark"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "40",
      "rows": "3"
    },
    domProps: {
      "value": _vm._s(_vm.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.remark = $event.target.value
      }
    }
  })])])]), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("閉じる")]), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.output()
      }
    }
  }, [_vm._v("出力")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v("発注内容出力")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h4', [_vm._v("発注内容出力")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('span', [_vm._v("×")])]), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("確認")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "ml5"
  }, [_vm._v("備考に記載する内容があれば記載してください。(最大40文字)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e8f7525e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/stock-output.pug
// module id = 899
// module chunks = 1